/**
 *
 * Every time you use a carousel, a kitten dies.
 *
 *          /\_/\
 *     ____/ o o \
 *   /~____  =ø= /
 *  (______)__m_m)
 *
 * Think of the kittens!
 *
 *
 * “Carousels pose accessibility issues for keyboard and screen reader users that simply cannot be adequately
 * addressed by markup or hacks. Carousels are this decade's <blink> tag.” -- jared smith
 *
 * More information about why carousels sucks on http://shouldiuseacarousel.com/
 */
(function() {
    'use strict';

    Odigeo.UIElements.enhanceCarousel = function(el, config) {
        var $el = el;
        var $slides;
        var $indicators;
        var numSlides;
        var switchToSlide;
        var prevSlide;
        var nextSlide;
        var goToSlide;
        var onButtonClick;
        var hideSlides;
        var index = 0;
        var intervalCarousel;
        var onSlideClick;
        var onSlideImageClick;
        var onCloseButtonClick;
        var draggable;
        var carousel = {
            startRotation: function() {
                if (!viewConfig.isRotationDisabled) {
                    clearInterval(intervalCarousel);
                    intervalCarousel = setInterval(function() {
                        nextSlide(false);
                    }, 6000);
                }
            },
            pauseRotation: function() {
                if (!viewConfig.isRotationDisabled) {
                    clearInterval(intervalCarousel);
                }
            },
        };
        var options = {
            indicatorChar: 'o',
            contentType: '',
        };
        var viewConfig = config || {};

        if (!el) {
            return;
        }

        if (!($el instanceof $)) {
            $el = $(el);
        }

        // Prevent further enhancements
        if ($el.attr('data-skip-enhance') === 'true') {
            return;
        }

        $el.attr({'data-skip-enhance': true});

        options = Odigeo._.extend(options, $el.data());

        $slides = $el.find('.carousel_slides .carousel_slide');
        $indicators = $el.find('.carousel_indicators');
        $slides.each(function() {
            $indicators.append($('<a>', {
                'class': 'od-ui-carousel-indicator carousel_goto',
                'text': options.indicatorChar,
            }));
        });
        $indicators = $indicators.find('.carousel_goto');

        numSlides = $slides.length;

        if (viewConfig.isDraggable) {
            draggable = viewConfig.draggableMixin.extend({
                onStart: function() {
                    this.setInitialPosition();
                },
                onEnd: function() {
                    if (this.currentPosition < this.initialPosition) {
                        nextSlide();
                    } else if (this.currentPosition > this.initialPosition) {
                        prevSlide();
                    }
                },
                onDrag: function(draggableData) {
                    this.currentPosition = this.calcultePosition(draggableData.move);

                    return this;
                },
                setInitialPosition: function() {
                    this.initialPosition = this.getPosition();

                    return this;
                },
                getPosition: function() {
                    return this.getTranslateX();
                },
                calcultePosition: function(offset) {
                    return this.initialPosition + offset.x;
                },
            });
        }

        switchToSlide = function(idx, track) {
            if (Odigeo._.isNaN(idx)) {
                return;
            }

            var $activeSlide = $el.find('.carousel_slides .carousel_slide.active');
            $slides.removeClass('active')
                .eq(idx).removeClass('not_loaded').addClass('active')
                .find('.carousel_logo_img').attr('src', function() {
                    return $(this).data('src');
                });

            Odigeo.trigger('checkLazyImages');

            Odigeo.UIElements.cmsTrackAdvertisement($slides.eq(idx));

            $indicators.eq(index).removeClass('active');
            $indicators.eq(idx).addClass('active');

            index = idx;
            carousel.startRotation();

            if (track) {
                // Analytics: event tracking
                Odigeo.trigger('analytics:tracking', {
                    type: 'trackEvent',
                    data: {
                        page: Odigeo.History.getPageNameFromFragment(),
                        action: 'carousel',
                        label: 'next_' + options.contentType + '_displayed_' + (idx + 1),
                    },
                });
            }

            if (viewConfig.hasImageCounter) {
                $el.find('.current_image_index').html(idx + 1);
                $el.find('.total_images').html(numSlides);
            }

            if (!Odigeo._.isUndefined(draggable)) {
                var $slide = $($slides.eq(idx));

                draggable.stopDraggable($slide);
                if (Odigeo._.size($activeSlide) > 0) {
                    draggable.stopDraggable($slides.eq($activeSlide.data('index')));
                }
                draggable.initDraggable($slide);
            }
        };

        prevSlide = function() {
            return switchToSlide(((index - 1) % numSlides + numSlides) % numSlides, true);
        };

        nextSlide = function(track) {
            return switchToSlide((index + 1) % numSlides, track);
        };

        goToSlide = function(e) {
            // Analytics: event tracking
            Odigeo.trigger('analytics:tracking', {
                type: 'trackEvent',
                data: {
                    page: Odigeo.History.getPageNameFromFragment(),
                    action: 'carousel',
                    label: 'next_' + options.contentType + '_displayed_' + ($(e.target).index() + 1),
                },
            });
            return switchToSlide($(e.target).index(), true);
        };

        onSlideImageClick = function(e) {
            if ($(e.target).hasClass('carousel_slide_img')) {
                if (viewConfig.isFullViewCarousel) {
                    nextSlide();
                    carousel.pauseRotation();
                } else {
                    Odigeo.trigger('slideImageTapped', e);
                }
            }
        };

        onSlideClick = function(e) {
            if ($(e.target).hasClass('carousel_slide') && viewConfig.isFullViewCarousel) {
                Odigeo.trigger('slideTapped', e);
            }
        };

        onCloseButtonClick = function(e) {
            if (viewConfig.isFullViewCarousel) {
                Odigeo.trigger('closeButtonClicked', e);
            }
        };

        onButtonClick = function(e) {
            var url = $(e.target).data('url');
            var target = $(e.target).data('target');
            var pos = $(e.target).data('pos');

            // Analytics: event tracking
            Odigeo.trigger('analytics:tracking', {
                type: 'trackEvent',
                data: {
                    page: Odigeo.History.getPageNameFromFragment(),
                    action: 'carousel',
                    label: 'select_' + options.contentType + '_' + pos,
                },
            });

            if (!Odigeo._.isEmpty(url)) {
                if (target === '_blank') {
                    Odigeo.trigger('analytics:tracking', {
                        type: 'sendToPageBlank',
                        data: {
                            url: url,
                        },
                    });
                } else {
                    Odigeo.trigger('analytics:tracking', {
                        type: 'sendToPageSelf',
                        data: {
                            url: url,
                        },
                    });
                }
            }
        };

        hideSlides = function() {
            $slides.addClass('odf-hidden');
            $indicators.addClass('odf-hidden');
            $el.find('.ficon').addClass('odf-hidden');
            carousel.pauseRotation();
        };

        $el
            .on(Odigeo.Events.tap, '.carousel_prev', Odigeo._.bind(prevSlide, this))
            .on(Odigeo.Events.tap, '.carousel_next', Odigeo._.bind(nextSlide, this, true))
            .on(Odigeo.Events.tap, '.carousel_goto', Odigeo._.bind(goToSlide, this))
            .on(Odigeo.Events.tap, 'button', Odigeo._.bind(onButtonClick, this))
            .on(Odigeo.Events.tap, '.carousel_slide', Odigeo._.bind(onSlideClick, this))
            .on(Odigeo.Events.tap, '.carousel_slide_img', Odigeo._.bind(onSlideImageClick, this))
            .on(Odigeo.Events.tap, '.close_carousel_button', Odigeo._.bind(onCloseButtonClick, this))
            .on(Odigeo.Events.mouseover, '.carousel_text', carousel.pauseRotation)
            .on('pause', carousel.pauseRotation)
            .on(Odigeo.Events.mouseout, '.carousel_text', carousel.startRotation)
            .on('start', carousel.startRotation)
            .on('hideSlides', hideSlides);

        // init with a random slide
        if (options.startWithRandom) {
            switchToSlide(Math.floor((Math.random() * numSlides)), false);
        } else {
            switchToSlide(0, false);
        }

        return $el;
    };
}());
